import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=4cb51dbb&scoped=true"
import script from "./DepartUserList.vue?vue&type=script&lang=js"
export * from "./DepartUserList.vue?vue&type=script&lang=js"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=4cb51dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb51dbb",
  null
  
)

export default component.exports